<template>
    <div :class="{'loading-attendance': holidaysPanelLoading}">
        <table class="table table-striped holidays-table">
            <thead>
                <tr>
                    <th colspan="3">{{ trans.attendance.holiday_panel.title.replace(":from", getStartOfPeriodDate()) }}</th>
                    <th class="text-right p-1 pr-2">
                        <!--
                            <b-btn v-b-tooltip.hover variant="warning" size="sm" :title="trans.attendance.holiday_panel.buttons.regenerate" v-on:click="regenerate()"><i class="fa fa-fw fa-sync text-black"></i></b-btn>
                        -->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="day in days">
                    <th>
                        {{ formatHolidaySelectOptionDate(day.date) }}
                    </th>
                    <td>
                        {{ formatHours(day.length) }}
                    </td>
                    <td style="width: 40%;">
                        <b-badge v-if="day.compensation_type == 1" variant="success">{{trans.attendance.holiday_panel.salary_addition}} ({{ day.label }})</b-badge>
                        <b-badge v-if="day.compensation_type == 2" variant="holiday">{{trans.attendance.holiday_panel.compensatory_leave}} ({{ day.label }})</b-badge>
                    </td>
                    <td class="text-right pr-2">
                        <button class="btn btn-secondary p-1" v-b-tooltip.hover v-b-tooltip.hover.left v-if="day.compensation_type == 1" type="button" v-on:click="changeType(day, 2)" :title="trans.attendance.holiday_panel.buttons.switch_nvp"><i class="fa fa-fw fa-umbrella-beach"></i></button>
                        <span v-if="day.compensation_type == 2" class="d-inline-block" tabindex="0" v-b-tooltip.hover.left :title="getSwitchAdditionTooltip(day)">
                            <button class="btn btn-secondary p-1" type="button" :disabled="!canChangeType(day)" v-on:click="changeType(day, 1)" :style="!canChangeType(day) ? 'pointer-events: none;' : ''"><i class="fa fa-fw fa-coins"></i></button>
                        </span>

                        <!--<div class="dropdown dropdown-holiday" :id="'dropdown-'+day.id">
                            <button type="button" class="btn btn-secondary p-2 dropdown-toggle" v-on:click="toggleDropdown(day.id)">
                                <i class="fas fa-ellipsis-v fa-fw text-black"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right">
                                <button class="dropdown-item" v-if="day.compensation_type == 1" type="button" v-on:click="changeType(day, 2)"><i class="fa fa-umbrella-beach"></i> {{trans.attendance.holiday_panel.buttons.switch_nvp }}</button>
                                <button class="dropdown-item" v-if="day.compensation_type == 2" type="button" v-on:click="changeType(day, 1)"><i class="fa fa-coins"></i> {{trans.attendance.holiday_panel.buttons.switch_addition }}</button>
                                <button class="dropdown-item text-danger" type="button" v-on:click="deleteItem(day)"><i class="fa fa-trash-alt text-danger"></i> {{trans.attendance.holiday_panel.buttons.delete }}</button>
                            </div>
                        </div>-->
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {formatHours} from "../../utils";
export default {
        name: 'holidays',
        data: function() {
            return {
                holidaysPanelLoading: false
            }
        },

        props: {
            'employeeContractId': {
                type: Number
            },
            'selectedMonth': {
                type: String
            },
            'holidaysRefreshUrl': {
                type: String
            },
            'month': {
                type: Number
            },
            'days': {
                type: Array
            },
            'trans': {
                type: Object
            },
        },


        methods: {
            formatHours(x) {
                return formatHours(x);
            },

            refreshAttendance(withLoading = true) {
                this.$parent.$emit('refreshattendance', withLoading);
            },

            formatHolidaySelectOptionDate(val)
            {
                return moment(val).format('DD.MM.YYYY');
            },

            getStartOfPeriodDate()
            {
                return moment(this.selectedMonth+"-01", "YYYY-MM-DD").subtract(3, 'month').format('DD.MM.YYYY');
            },

            canChangeType(day) {
                // DA-876:
                // always when changing in direction: addition -> compensated day (NVP holiday)
                // in direction: compensated day -> addition ONLY if not already assigned "NVP holiday" work_day_interval item
                return day.compensation_type === 1 || day.compensated_by === null;
            },

            getSwitchAdditionTooltip(day) {
                if (this.canChangeType(day)) {
                    return this.trans.attendance.holiday_panel.buttons.switch_addition;
                }

                return this.trans.attendance.holiday_panel.buttons.switch_addition_disabled;
            },

            changeType(day, type)
            {
                let _this = this;
                _this.closeAllDropdowns();
                _this.holidaysPanelLoading = true;

                axios.post("/worked-holidays/"+day.id+"/change-type/"+type).then(function (response) {
                    _this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                    _this.holidaysPanelLoading = false;
                    _this.refreshHolidaysData();
                    _this.refreshAttendance();
                }, function (error) {
                    _this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                    _this.holidaysPanelLoading = false;
                });
            },

            deleteItem(day)
            {
                let _this = this;
                _this.closeAllDropdowns();
                _this.holidaysPanelLoading = true;

                axios.post("/worked-holidays/"+day.id+"/delete").then(function (response) {
                    _this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                    _this.holidaysPanelLoading = false;
                    _this.refreshHolidaysData();
                    _this.refreshAttendance();
                }, function (error) {
                    _this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                    _this.holidaysPanelLoading = false;
                });
            },

            regenerate()
            {
                let _this = this;
                _this.holidaysPanelLoading = true;

                axios.post("/worked-holidays/regenerate/"+_this.employeeContractId+"/"+_this.selectedMonth).then(function (response) {
                    _this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully updated.' });
                    _this.holidaysPanelLoading = false;
                    _this.refreshHolidaysData();
                    _this.refreshAttendance();
                }, function (error) {
                    _this.$notify({ type: 'error', title: 'Error!', text: error.response.data.message ? error.response.data.message : 'An error has occured.' });
                    _this.holidaysPanelLoading = false;
                });
            },

            refreshHolidaysData()
            {
                this.$emit('refreshworkedholidays');
            },

            closeAllDropdowns(exceptId)
            {
                $(".dropdown-holiday.open").not("#dropdown-"+exceptId).removeClass("open");
            },

            toggleDropdown(id)
            {
                this.closeAllDropdowns(id);
                $("#dropdown-"+id).toggleClass('open');
            }
        },
        computed: {

        }
    }
</script>


<style lang="scss" scoped>
    .btn-square-loading-save,
    .btn.loading.btn-square-loading-save {
        width: 38px;
        height: 35px;
        padding-right: 0.75rem !important;
        text-align: center;

        .loadingSpinner {
            margin-left: -10px;
            left: auto;
            right: auto;
        }
    }
    .form-control {
        padding-right: 12px !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/Holidays.vue